// Live Notifications
export async function fetchLiveNotifications({
  expo_token,
  pkp_eth_address,
  operation = 'and'
}) {
  try {
    const params = new URLSearchParams(Object.assign(Object.assign(Object.assign({}, expo_token && {
      expo_token
    }), pkp_eth_address && {
      pkp_eth_address
    }), operation && {
      operation
    }));
    const response = await fetch(`/api/db/notification-live?${params === null || params === void 0 ? void 0 : params.toString()}`);
    if (!response.ok) return {
      error: 'Network response was not ok'
    };
    return {
      data: await response.json()
    };
  } catch (error) {
    console.error('Error fetching notification tokens:', error);
    return {
      error: error.message
    };
  }
}
export async function createOrUpdateLiveNotification(newToken) {
  try {
    const response = await fetch('/api/db/notification-live', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newToken)
    });
    if (!response.ok) return {
      error: 'Network response was not ok'
    };
    return {
      data: await response.json()
    };
  } catch (error) {
    console.error('Error creating notification token:', error);
    return {
      error: error.message
    };
  }
}
// Notification Logs
export async function fetchNotificationLogs({
  notification_type,
  notification_batch_id,
  status,
  operation = 'and'
}) {
  try {
    const params = new URLSearchParams(Object.assign(Object.assign(Object.assign(Object.assign({}, notification_type && {
      notification_type
    }), notification_batch_id && {
      notification_batch_id: notification_batch_id === null || notification_batch_id === void 0 ? void 0 : notification_batch_id.toString()
    }), status && {
      status
    }), operation && {
      operation
    }));
    const response = await fetch(`/api/db/notification-logs?${params === null || params === void 0 ? void 0 : params.toString()}`);
    if (!response.ok) return {
      error: 'Network response was not ok'
    };
    return {
      data: await response.json()
    };
  } catch (error) {
    console.error('Error fetching notification logs:', error);
    return {
      error: error.message
    };
  }
}
export async function createNotificationLog(newLog) {
  try {
    const response = await fetch('/api/db/notification-logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(newLog)
    });
    if (!response.ok) return {
      error: 'Network response was not ok'
    };
    return {
      data: await response.json()
    };
  } catch (error) {
    console.error('Error creating notification log:', error);
    return {
      error: error.message
    };
  }
}
export async function updateNotificationLog(id, updates) {
  try {
    const response = await fetch('/api/db/notification-logs', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Object.assign({
        id
      }, updates))
    });
    if (!response.ok) return {
      error: 'Network response was not ok'
    };
    return {
      data: await response.json()
    };
  } catch (error) {
    console.error('Error updating notification log:', error);
    return {
      error: error.message
    };
  }
}